// extracted by mini-css-extract-plugin
module.exports = {"NewsList":"NewsList--16Toc","header":"header--1FWxb","headerLeft":"headerLeft--1Y0B9","headerRight":"headerRight--iYgdg","content":"content--29Ler"};